export default "__VITE_ASSET__CV70vTQk__"